import {FUIContextType} from "./form-context-type";
import {Injectable} from "@angular/core";

/**
 * Injected into content-layout controls to indicate which form-context they are being displayed in. The same control may have
 * different look and feels for different contexts.
 *
 * Sub classes provide the form-context type in the constructor.
 *
 * Wrapper/container components may provide their form-context via:
 * providers: [{provide: FUIFormContext, useClass: FUIFilterFormContext}]
 *
 * where useClass specifies the actual form-context class.
 */
@Injectable()
export abstract class FUIFormContext {

    constructor(public type: FUIContextType, public name: string) {
    }

}
